import CluppTextArea from "../../../Components/CluppForms/CluppTextArea";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const TrustInClupp = ({ state, setState, field }) => {
  return (
    <>
      <TitleHeaders
        title={"¿Qué no te dió confianza?"}
        subtitle={""}
        isRequired={true}
      />
      <CluppTextArea
        state={state}
        label={"Explícanos brevemente"}
        multiline={true}
        setState={setState}
        field={field}
        variant="filled"
        autoFocus={true}
      />
    </>
  );
};

export default TrustInClupp;
